var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath217(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.603,
    height: 42.6,
    viewBox: "0 0 64.603 42.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1,0H5.5A5.549,5.549,0,0,0,0,5.5V37.1a5.549,5.549,0,0,0,5.5,5.5H59.1a5.549,5.549,0,0,0,5.5-5.5V5.5A5.421,5.421,0,0,0,59.1,0ZM7.9,8h8a3.222,3.222,0,0,1,3.2,3.2,3.159,3.159,0,0,1-3.2,3.2h-8a3.222,3.222,0,0,1-3.2-3.2A3.159,3.159,0,0,1,7.9,8ZM60,30.3H4.7v-9H60Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath217);
export default __webpack_public_path__ + "static/media/Path 217.83bc8d39fd7b0077fd91a80d100d6fde.svg";
export { ForwardRef as ReactComponent };